import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  loading: false,
  error: null,
}

const addStaticPageSlice = createSlice({
  name: "addStaticPage",
  initialState,
  reducers: {
    add(state) {
      state.loading = true
      state.error = null
    },
    addCompleted(state) {
      state.loading = false
    },
    addRejected(state, action) {
      state.loading = false
      state.error = action.payload
    },
    cleanState() {
      return initialState
    },
  },
})

/**
 * @namespace
 * @property {function} add
 * @property {function} addCompleted
 * @property {function} addRejected
 *  @property {function} cleanState
 */
export const addStaticPage = addStaticPageSlice.actions

export default addStaticPageSlice.reducer
